<div class="flex flex-column w-full h-screen min-h-screen">
  <!-- Navigation -->
  <medsurf-navbar></medsurf-navbar>
  
  <!-- Media Library -->
  <medsurf-common-media-library [class]="'w-full h-full overflow-hidden'"></medsurf-common-media-library>
</div>
